import { getCountryList } from 'services';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ICountryStore = {
  countries: any;
  selectedCountry: { label: string; value: string } | null;
  isCountryListLoading: boolean;
  error: any;
  reportName: string;
  selectedCountryCode: string | null;
  addReportName: (name: string) => void;
  updateSelectedCountry: (country: { label: string; value: string }) => void;
  updateSelectedCountryCode: (countryCode: string) => void;
  getCountryList: () => void;
  resetCountryStore: () => void;
};
const initialState = {
  countries: [],
  selectedCountry: null,
  isCountryListLoading: false,
  reportName: '',
  error: null,
  selectedCountryCode: null,
};
//  needs to be optimized
const useCountryStore = create<ICountryStore, [['zustand/persist', unknown]]>(
  persist(
    (set) => ({
      ...initialState,
      addReportName: (name) => set({ reportName: name }),
      updateSelectedCountry: (country) => set({ selectedCountry: country }),
      updateSelectedCountryCode: (countryCode) => set({ selectedCountryCode: countryCode }),
      getCountryList: async (): Promise<any> => {
        try {
          set((state) => ({ ...state, isCountryListLoading: true }));
          const response: any = await getCountryList();
          const { responseCode, data } = response;
          if (responseCode === 200) {
            let _countries = data.countryList.map((country: any) => ({
              label: country.countryName,
              value: country.countryCode,
            }));
            set({ countries: _countries });
          }
        } catch (error) {
          console.error('Failed to fetch countries', error);
          set({ error });
        } finally {
          set({ isCountryListLoading: false });
        }
      },
      resetCountryStore: () =>
        set((state) => {
          return {
            ...initialState,
            countries: state.countries,
            selectedCountry: null,
            isCountryListLoading: false,
            reportName: '',
            error: null,
            selectedCountryCode: null,
          };
        }),
    }),
    {
      name: 'kf1-countryStore', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => window.sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export default useCountryStore;
